export enum CookieAnalytics {
  ALL = 'ALL',
  ALL_DIALOG = 'ALL_DIALOG',
  ESSENTIAL_DIALOG = 'ESSENTIAL_DIALOG',
}
